export default "__VITE_ASSET__D82GlecR__"